import { render, staticRenderFns } from "./dots_export.vue?vue&type=template&id=378923f4&scoped=true&"
import script from "./dots_export.vue?vue&type=script&lang=js&"
export * from "./dots_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378923f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('378923f4')) {
      api.createRecord('378923f4', component.options)
    } else {
      api.reload('378923f4', component.options)
    }
    module.hot.accept("./dots_export.vue?vue&type=template&id=378923f4&scoped=true&", function () {
      api.rerender('378923f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/dots/dots_export.vue"
export default component.exports